/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { DataPeriods } from '@g17eco/types/universalTracker';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { PeriodOption, getPeriodOptionLabel, getSurveyPeriodOptions } from './utils';

export interface PeriodDropdownProps<T extends PeriodOption = DataPeriods> {
  className?: string;
  disabled?: boolean;
  availablePeriods: T[];
  period?: T;
  setPeriod?: (period: T) => void;
  hasAllOption?: boolean;
}

export const SurveyPeriodDropdown = <T extends PeriodOption = DataPeriods>(props: PeriodDropdownProps<T>) => {
  const {
    className,
    disabled = false,
    availablePeriods,
    period = DataPeriods.Yearly,
    setPeriod,
    hasAllOption = false,
  } = props;

  if (availablePeriods.length === 0) {
    return null;
  }

  const isDisabled = (p: T) => {
    return period === p || !availablePeriods.includes(p);
  };

  const options = getSurveyPeriodOptions<T>(hasAllOption);

  return (
    <UncontrolledDropdown disabled={disabled} className={className}>
      <DropdownToggle disabled={disabled} className='text-truncate' color='transparent' outline caret>
        <span className='px-2'>{getPeriodOptionLabel(period)}</span>
      </DropdownToggle>
      <DropdownMenu end>
        {options.map((dataPeriod) => (
          <DropdownItem
            key={dataPeriod}
            active={period === dataPeriod}
            disabled={isDisabled(dataPeriod)}
            onClick={() => setPeriod?.(dataPeriod)}
          >
            {getPeriodOptionLabel(dataPeriod)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
